import { render, staticRenderFns } from "./BlockCurtain.vue?vue&type=template&id=7f5dfab8&scoped=true"
import script from "./BlockCurtain.vue?vue&type=script&lang=ts"
export * from "./BlockCurtain.vue?vue&type=script&lang=ts"
import style0 from "./BlockCurtain.vue?vue&type=style&index=0&id=7f5dfab8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5dfab8",
  null
  
)

export default component.exports